import {
  Button,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ForwardedRef, forwardRef, useEffect } from "react";

import { usePathname } from "hooks/use-pathname";
import useFunctions from "layouts/dashboard-layout/ts/useFunctions";
import { Link } from "react-router-dom";

export default function NavItem({ item }: { item: any }) {
  const pathname = usePathname();
  const theme = useTheme();
  const isBelowLg = useMediaQuery(theme.breakpoints.down("lg"));
  const { setOpen } = useFunctions();

  let itemTarget = "_self";
  if (item.target) {
    itemTarget = "_blank";
  }
  const drawerOpen = true;
  const isSelected = item.url === pathname;

  type AnchorRef = ForwardedRef<HTMLAnchorElement>;
  type ButtonRef = ForwardedRef<HTMLButtonElement>;
  let listItemProps = {
    component:
      item.type === "link"
        ? forwardRef<AnchorRef, any>((props, ref) => (
            <Link ref={ref} {...props} to={item.url} target={itemTarget} />
          ))
        : forwardRef<ButtonRef, any>((props, ref) => (
            <Button
              ref={ref}
              {...props}
              to={item.url || ""}
              target={itemTarget}
              sx={{ width: "100%" }}
            />
          )),
  };

  listItemProps.component.displayName = "ListItemLink";

  const itemHandler = () => {
    if (item.onClick) item.onClick();
    if (isBelowLg) setOpen(false);
  };

  const Icon = item.icon;
  const itemIcon = item.icon ? (
    <Icon style={{ fontSize: drawerOpen ? "1rem" : "1.25rem" }} />
  ) : (
    false
  );

  useEffect(() => {
    if (pathname.includes(item.url)) {
    }
    // eslint-disable-next-line
  }, [pathname]);

  const textColor = "#636363 !important";
  const iconSelectedColor = "#fff";
  return (
    <Tooltip title={item.title} arrow placement="right">
      <ListItemButton
        {...listItemProps}
        disabled={item.disabled}
        onClick={itemHandler}
        selected={isSelected}
        sx={{
          my: 1,
          pl: 2,
          py: 1.5,
          gap: 1,
          overflow: "hidden",
          "&:hover": {
            "& svg": {
              fill: iconSelectedColor,
            },
            "& span": {
              color: iconSelectedColor,
            },
          },
        }}
      >
        {itemIcon && (
          <ListItemIcon
            sx={{
              minWidth: 28,
              color: isSelected ? iconSelectedColor : textColor,
              fill: textColor,
              "& svg": {
                width: "22px",
                height: "22px",
              },
            }}
          >
            {itemIcon}
          </ListItemIcon>
        )}

        <ListItemText
          sx={{
            fontSize: "17px",
          }}
          primary={item.title}
        />
      </ListItemButton>
    </Tooltip>
  );
}
